import { getCartToken, removeCartToken } from "./tokens/cart-token";
import { getWishlistToken, removeWishlistToken } from "./tokens/wishlist-token";
import { setUserTokenResponse } from "./tokens/user-token-response";
import axios from "axios";
const login = async (fetch, getTokenParameters, associateGuestCart, associateGuestWishlist)=>{
    const { data: spreeGetTokenSuccessResponse  } = await fetch({
        variables: {
            methodPath: "authentication.getToken",
            arguments: [
                getTokenParameters
            ]
        }
    });
    setUserTokenResponse(spreeGetTokenSuccessResponse);
    if (associateGuestCart) {
        const cartToken = getCartToken();
        if (cartToken) {
            // If the user had a cart as guest still use its contents
            // after logging in.
            const accessToken = spreeGetTokenSuccessResponse.access_token;
            const token = {
                bearerToken: accessToken
            };
            const associateGuestCartParameters = {
                guest_order_token: cartToken
            };
            await fetch({
                variables: {
                    methodPath: "cart.associateGuestCart",
                    arguments: [
                        token,
                        associateGuestCartParameters
                    ]
                }
            });
        // We no longer need the guest cart token, so let's remove it.
        }
    }
    removeCartToken();
    if (associateGuestWishlist) {
        const wishlistToken = getWishlistToken();
        if (wishlistToken) {
            // If the user had a wishlist as guest still use its contents
            // after logging in.
            const accessToken1 = spreeGetTokenSuccessResponse.access_token;
            const options = {
                method: "PATCH",
                url: `${process.env.storefrontApiUrl}/wishlists/associate`,
                params: {
                    guest_wishlist_token: wishlistToken
                },
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/vnd.api+json",
                    Authorization: `Bearer ${accessToken1}`
                }
            };
            try {
                await axios.request(options);
            } catch (error) {
                console.error(error);
            }
        // We no longer need the guest wishlist token, so let's remove it.
        }
    }
    removeWishlistToken();
};
export default login;
